import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-salesmanagershopitems-main",
    templateUrl: "./salesmanagershopitems.main.component.html",
    standalone: false
})
export class SalesManagerShopItemsMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
